module.exports = __webpack_public_path__ + "static/media/Meditation.9aa7a329.png";